export default __webpack_public_path__ + "static/media/logo-site-colors.5c4ec9eb.png";